import { COLORS, SPACING } from '@alto/design-library-tokens';
import { TEXT_COLORS } from '@alto/design-library-tokens/src/colors/textColors';
import { Body, Column, ExternalLink, LgSpacing, Row, useScreenSize } from '@alto/design-system';
import { getYear } from 'date-fns';
import React from 'react';
import styled, { css } from 'styled-components';
import { PRIVACY_POLICY_URL, PRIVACY_PRACTICES_URL, TERMS_OF_SERVICE_URL } from '~shared/constants';
import logoPharmacy from '~web/images/altoLogo@2x.png';

const FooterPhoneCss = css`
  padding: ${SPACING.STATIC.LG.rem} ${SPACING.STATIC.LG.rem} ${SPACING.STATIC.MD.rem};
`;

const Logo = styled.div`
  height: 44px;
  width: 85px;
  margin-bottom: ${SPACING.STATIC.LG.rem};
  background-image: url(${logoPharmacy});
  background-size: 85px 44px;
`;

const StyledFooter = styled.footer<{ isSMScreenOrBigger: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${SPACING.STATIC.XL.rem} ${SPACING.STATIC.XL.rem} ${SPACING.STATIC.LG.rem};
  background-color: ${COLORS.PALETTE.GREYSCALE.DEFAULT};
  ${({ isSMScreenOrBigger }) => !isSMScreenOrBigger && FooterPhoneCss}
`;

export const Footer = () => {
  const { isSMScreenOrBigger, isMDScreenOrBigger } = useScreenSize();
  const Layout = isMDScreenOrBigger ? Row : Column;

  return (
    <StyledFooter isSMScreenOrBigger={isSMScreenOrBigger}>
      <Logo />
      <Layout
        wrap
        spaceBetween
      >
        <Layout wrap>
          <ExternalLink
            color={COLORS.TEXT_COLORS.DISABLED}
            href={PRIVACY_POLICY_URL}
            fontFamily="semibold"
          >
            Privacy Policy
          </ExternalLink>
          <LgSpacing />
          <ExternalLink
            color={COLORS.TEXT_COLORS.DISABLED}
            href={PRIVACY_PRACTICES_URL}
            fontFamily="semibold"
          >
            Notice of Privacy Practices
          </ExternalLink>
          <LgSpacing />
          <ExternalLink
            color={COLORS.TEXT_COLORS.DISABLED}
            href={TERMS_OF_SERVICE_URL}
            fontFamily="semibold"
          >
            Terms & Conditions
          </ExternalLink>
          <LgSpacing />
        </Layout>
        <Body color={TEXT_COLORS.DISABLED}>{`\u00A9 ${getYear(new Date())} Alto Pharmacy. All rights reserved.`}</Body>
      </Layout>
    </StyledFooter>
  );
};
